var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2C0.895431 2 0 2.89543 0 4V23C0 24.6569 1.34315 26 3 26H25C26.6569 26 28 24.6569 28 23V9C28 7.34315 26.6569 6 25 6H12.9538L10.0514 2.68299C9.67161 2.24896 9.12296 2 8.54623 2H2ZM10.2962 6L8.54623 4H2V6H10.2962ZM2 8H25C25.5523 8 26 8.44772 26 9V23C26 23.5523 25.5523 24 25 24H3C2.44772 24 2 23.5523 2 23V8Z",
    fill: "#3D3D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d49c6f80ebc2857c0ed7271839017a35.svg";
export { ForwardRef as ReactComponent };